// src/components/PackageCardAlpha.jsx
import React, { useMemo } from "react";
import { Link } from "react-router-dom";

/* Same colour palette the list view uses */
const artformColors = {
  music: "#367591",
  sound: "#009FE3",
  film: "#FBF299",
  art: "#E6007E",
  environment: "#6EBC86",
  writing: "#7B6A58",
  activism: "#E24259",
  performance: "#725283",
  video: "#ABD194",
  vr: "#4D4C4C",
};

function PackageCardAlpha({ workshop }) {
  const {
    id,
    url,
    course_image,
    artforms,
    date,
    duration,
    ctype,
    title_with,
    tutors,
    places,
    placesword,
  } = workshop;

  /* One‑off helper so we don’t recompute on every render */
  const artformTags = useMemo(() => {
    if (!artforms) return null;
    return artforms
      .split(",")
      .map((af) => af.trim().toLowerCase())
      .map((af) => (
        <span
          key={af}
          style={{
            backgroundColor: artformColors[af] || "#888",
            color: "white",
            borderRadius: 8,
            padding: "4px 8px",
            fontSize: "0.8rem",
            marginRight: 4,
            marginBottom: 4,
            whiteSpace: "nowrap",
          }}
        >
          {af}
        </span>
      ));
  }, [artforms]);

  /* Give each card a deterministic tutor colour */
  const tutorColorClasses = [
    "txt-gradient-1",
    "txt-gradient-2",
    "txt-gradient-3",
    "txt-gradient-4",
    "txt-gradient-5",
    "txt-gradient-6",
  ];
  const tutorClass = tutorColorClasses[Math.floor(Math.random() * tutorColorClasses.length)];

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="package-card-beta">
      {/* ---------- thumbnail ---------- */}
      <div className="package-thumb">
        <Link to={`${process.env.PUBLIC_URL}${url}`} onClick={scrollTop}>
          <img src={`${process.env.PUBLIC_URL}${course_image}`} alt={title_with} />
        </Link>

        {/* pills wrap automatically thanks to flex‑wrap in CSS */}
        <div className="artformcontainer">{artformTags}</div>

        <p className="card-lavel">
          <i className="bi bi-clock" /> <span className="card-lavel-t1">{date}</span>
          {ctype === "onsite" && (
            <>
              {" / "}
              <span className="card-lavel-t1">{duration}</span>
            </>
          )}
          {" / "}
          <span className={`card-lavel-t3-${ctype}`}>{ctype}</span>
        </p>
      </div>

      {/* ---------- body ---------- */}
      <div className="package-card-body">
        <h3 className="p-card-title">
          <Link to={`${process.env.PUBLIC_URL}${url}`} onClick={scrollTop}>
            {title_with} <span className={tutorClass}>{tutors}</span>
          </Link>
        </h3>

        <div className="p-card-bottom">
          <div className="book-btn">
            <Link to={`${process.env.PUBLIC_URL}${url}`} onClick={scrollTop}>
              Book Now <i className="bx bxs-right-arrow-alt" />
            </Link>
          </div>
          <div className="p-card-info">
            <h6>
              {places} <span>{placesword}</span>
            </h6>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PackageCardAlpha;
